import React, { useState } from 'react'
import { Edit2, X, Package, FileText, Download, Send } from 'lucide-react'
import { formatCurrency, formatDate } from '../../utils/formatters'
import './PurchaseDetailModal.scss'
import authService from '../../services/authService'

const PurchaseDetailModal = ({
  shopInfo,
  purchase,
  isOpen,
  onClose,
  onEdit,
}) => {
  const [localImageModal, setLocalImageModal] = useState(null)
  const [showInvoiceMenu, setShowInvoiceMenu] = useState(false)

  if (!isOpen || !purchase) return null

  const currentPlan = authService.getCurrentPlan()
  const generateInvoiceHTML = () => {
    if (currentPlan.id === 'standard' || currentPlan.id === 'premium') {
      const paid =
        purchase.paymentMethods?.reduce(
          (total, pm) => total + Number(pm.amount || 0),
          0,
        ) || 0

      return `
                    <!DOCTYPE html>
                    <html>
                    <head>
                      <meta charset="utf-8">
                      <link rel="preconnect" href="https://fonts.googleapis.com">
                      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap" rel="stylesheet">
                      <title>Facture - ${purchase.clientName}</title>
                      <style>
                        * { margin: 0; padding: 0; box-sizing: border-box; }
                        body { 
                          font-family: 'Outfit', 'Segoe UI', Arial, sans-serif; 
                          padding: 40px; 
                          color: #333;
                          background: #f5f5f5;
                        }
                        .invoice-container {
                          max-width: 800px;
                          margin: 0 auto;
                          background: white;
                          padding: 50px;
                          box-shadow: 0 0 20px rgba(0,0,0,0.1);
                        }
                        .header {
                          text-align: center;
                          margin-bottom: 40px;
                          border-bottom: 3px solid #2563eb;
                          padding-bottom: 20px;
                        }
                        .header h1 {
                          font-size: 36px;
                          color: #2563eb;
                          margin-bottom: 10px;
                        }
                        .header .invoice-number {
                          color: #666;
                          font-size: 14px;
                        }
                        .info-section {
                          display: flex;
                          justify-content: space-between;
                          margin-bottom: 40px;
                        }
                        .info-block {
                          flex: 1;
                        }
                        .info-block h3 {
                          font-size: 12px;
                          text-transform: uppercase;
                          color: #666;
                          margin-bottom: 10px;
                          letter-spacing: 1px;
                        }
                        .info-block p {
                          margin: 5px 0;
                          line-height: 1.6;
                        }
                        .products-table {
                          width: 100%;
                          border-collapse: collapse;
                          margin: 30px 0;
                        }
                        .products-table thead {
                          background: #f8f9fa;
                        }
                        .products-table th {
                          padding: 15px;
                          text-align: left;
                          font-weight: 600;
                          border-bottom: 2px solid #e5e7eb;
                          font-size: 13px;
                          text-transform: uppercase;
                          color: #666;
                          letter-spacing: 0.5px;
                        }
                        .products-table td {
                          padding: 15px;
                          border-bottom: 1px solid #e5e7eb;
                        }
                        .products-table tbody tr:hover {
                          background: #f8f9fa;
                        }
                        .product-details {
                          font-size: 12px;
                          color: #666;
                          margin-top: 3px;
                        }
                        .text-right { text-align: right; }
                        .text-center { text-align: center; }
                        .totals-section {
                          margin-top: 30px;
                          padding-top: 20px;
                          border-top: 2px solid #e5e7eb;
                        }
                        .totals-table {
                          width: 100%;
                          max-width: 350px;
                          margin-left: auto;
                        }
                        .totals-table tr td {
                          padding: 8px 15px;
                        }
                        .totals-table tr:last-child {
                          border-top: 2px solid #2563eb;
                        }
                        .totals-table tr:last-child td {
                          font-weight: bold;
                          font-size: 18px;
                          padding-top: 15px;
                          color: #2563eb;
                        }
                        .payment-section, .delivery-section {
                          margin: 30px 0;
                          padding: 20px;
                          background: #f8f9fa;
                          border-radius: 8px;
                        }
                        .payment-section h3, .delivery-section h3 {
                          font-size: 14px;
                          text-transform: uppercase;
                          color: #666;
                          margin-bottom: 10px;
                          letter-spacing: 1px;
                        }
                        .payment-method {
                          display: flex;
                          justify-content: space-between;
                          padding: 8px 0;
                          text-transform: capitalize;
                        }
                        .observations {
                          margin: 30px 0;
                          padding: 20px;
                          background: #fffbeb;
                          border-left: 4px solid #f59e0b;
                          border-radius: 4px;
                        }
                        .observations h3 {
                          font-size: 14px;
                          color: #f59e0b;
                          margin-bottom: 10px;
                        }
                        .observations p {
                          font-style: italic;
                          color: #666;
                          line-height: 1.6;
                        }
                        .footer {
                          margin-top: 50px;
                          padding-top: 20px;
                          border-top: 1px solid #e5e7eb;
                          text-align: center;
                          color: #999;
                          font-size: 12px;
                        }
                        .badge {
                          display: inline-block;
                          padding: 4px 12px;
                          border-radius: 12px;
                          font-size: 12px;
                          font-weight: 600;
                        }
                        .badge-success {
                          background: #dcfce7;
                          color: #166534;
                        }
                        .badge-warning {
                          background: #fef3c7;
                          color: #92400e;
                        }
                        @media print {
                          body { padding: 0; background: white; }
                          .invoice-container { box-shadow: none; }
                        }
                      </style>
                    </head>
                    <body>
                      <div class="invoice-container">
                        <div class="header">
                          <h1>FACTURE</h1>
                          <p class="invoice-number">Date de l'achat : ${formatDate(purchase.date)}</p>
                          <p class="invoice-number">Date de génération de la facture : ${formatDate(new Date())}</p>
                        </div>
              
                        <div class="info-section">
                          <div class="info-block">
                            <h3>Client</h3>
                            <p><strong>${purchase.clientName}</strong></p>
                            ${purchase.clientPhone ? `<p>${purchase.clientPhone}</p>` : ''}
                          </div>
              
                          <div class="info-block">
                            <h3>Boutique</h3>
                            <p><strong>${shopInfo.shopName}</strong></p>
                            <p><strong>Représentant:</strong> ${shopInfo.ownerName}</p>
                            <p>${shopInfo.email}</p>
                            <p>${shopInfo.phone}</p>
                          </div>
                        </div>
              
                        <table class="products-table">
                          <thead>
                            <tr>
                              <th>Produit</th>
                              <th class="text-center">Quantité</th>
                              <th class="text-right">Prix unitaire</th>
                              <th class="text-right">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            ${purchase.items
                              .map(
                                (item) => `
                              <tr>
                                <td>
                                  <strong>${item.productName}</strong>
                                  ${
                                    item.productSize || item.productColor
                                      ? `
                                    <div class="product-details">
                                      ${[item.productSize, item.productColor].filter(Boolean).join(', ')}
                                    </div>
                                  `
                                      : ''
                                  }
                                </td>
                                <td class="text-center">${item.quantity}</td>
                                <td class="text-right">${formatCurrency(item.unitPrice)}</td>
                                <td class="text-right"><strong>${formatCurrency(item.total)}</strong></td>
                              </tr>
                            `,
                              )
                              .join('')}
                          </tbody>
                        </table>
              
                        ${
                          purchase.paymentMethods || purchase.paymentMethod
                            ? `
                          <div class="payment-section">
                            <h3>Modes de paiement</h3>
                            ${
                              purchase.paymentMethods
                                ? purchase.paymentMethods
                                    .map(
                                      (pm) => `
                                <div class="payment-method">
                                  <span>${pm.method.replace('-', ' ')}</span>
                                  <strong>${formatCurrency(pm.amount)}</strong>
                                </div>
                              `,
                                    )
                                    .join('')
                                : `<p>${purchase.paymentMethod.replace('-', ' ')}</p>`
                            }
                          </div>
                        `
                            : ''
                        }
              
                        ${
                          purchase.deliveryStatus &&
                          purchase.deliveryStatus !== 'default'
                            ? `
                          <div class="delivery-section">
                            <h3>Informations de livraison</h3>
                            <p>
                              Statut: 
                              <span class="badge ${purchase.deliveryStatus === 'delivered' ? 'badge-success' : 'badge-warning'}">
                                ${purchase.deliveryStatus === 'delivered' ? 'Livré' : 'À livrer'}
                              </span>
                            </p>
                            ${purchase.adressDelivery ? `<p style="margin-top: 10px;"><strong>Adresse:</strong> ${purchase.adressDelivery}</p>` : ''}
                          </div>
                        `
                            : ''
                        }
              
                        ${
                          purchase.observations
                            ? `
                          <div class="observations">
                            <h3>Observations</h3>
                            <p>${purchase.observations}</p>
                          </div>
                        `
                            : ''
                        }
              
                        <div class="totals-section">
                          <table class="totals-table">
                            <tr>
                              <td>Total:</td>
                              <td class="text-right"><strong>${formatCurrency(purchase.totalAmount)}</strong></td>
                            </tr>
                            ${
                              purchase.totalPaid !== undefined
                                ? `
                              <tr>
                                <td>Payé:</td>
                                <td class="text-right">${formatCurrency(paid)}</td>
                              </tr>
                            `
                                : ''
                            }
                            ${
                              purchase.remainingAmount > 0
                                ? `
                              <tr>
                                <td>Reste à payer:</td>
                                <td class="text-right" style="color: #dc2626;">${formatCurrency(purchase.remainingAmount)}</td>
                              </tr>
                            `
                                : ''
                            }
                            <tr>
                              <td>TOTAL NET :</td>
                              <td class="text-right">${formatCurrency(purchase.totalAmount)}</td>
                            </tr>
                          </table>
                        </div>
              
                        <div class="footer">
                          <p>Merci de votre confiance</p>
                          <p>Powered by ogc.laguindaws.com</p>
                        </div>
                      </div>
                    </body>
                    </html>
                  `
    }
    return
  }

  const downloadPDF = () => {
    const htmlContent = generateInvoiceHTML()
    const blob = new Blob([htmlContent], { type: 'text/html' })
    const url = URL.createObjectURL(blob)
    const printWindow = window.open(url, '_blank')

    if (printWindow) {
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print()
        }, 250)
      }
    }

    setShowInvoiceMenu(false)
  }

  const openWhatsApp = () => {
    // Déterminer le salut selon l'heure
    const currentHour = new Date().getHours()
    const greeting = currentHour >= 14 ? 'Bonsoir' : 'Bonjour'

    // Créer le message
    const message = `${greeting} ${purchase.clientName}, voici la facture de votre achat éffectué dans notre boutique.`

    const encodedMessage = encodeURIComponent(message)
    const phoneNumber = purchase.clientPhone?.replace(/\D/g, '') || ''
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`

    window.open(whatsappUrl, '_blank')
    setShowInvoiceMenu(false)
  }

  return (
    <div className='modal-overlay'>
      <div className='modal-content sm'>
        <div className='modal-header'>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px',
            }}
          >
            <h2 className='modal-title'>Détails de l'achat</h2>

            <div style={{ position: 'relative' }}>
              {(currentPlan.id === 'standard' ||
                currentPlan.id === 'premium') && (
                <button
                  onClick={() => setShowInvoiceMenu(!showInvoiceMenu)}
                  className='btn primary'
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <FileText size={16} />
                  Facture
                </button>
              )}

              {showInvoiceMenu && (
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: '8px',
                    backgroundColor: 'white',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                    minWidth: '220px',
                  }}
                >
                  <button
                    onClick={downloadPDF}
                    className='btn secondary'
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                      gap: '8px',
                      borderRadius: '8px 8px 0 0',
                      border: 'none',
                      borderBottom: '1px solid #e5e7eb',
                    }}
                  >
                    <Download size={16} />
                    Télécharger PDF
                  </button>
                  <button
                    onClick={openWhatsApp}
                    className='btn secondary'
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                      gap: '8px',
                      borderRadius: '0 0 8px 8px',
                      border: 'none',
                    }}
                  >
                    <Send size={16} />
                    Ouvrir WhatsApp
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className='form-group'>
            <div className='form-grid cols-2'>
              <div className='form-field'>
                <label>Client</label>
                <p className='font-medium'>{purchase.clientName}</p>
              </div>
              <div className='form-field'>
                <label>Date</label>
                <p className='font-medium'>{formatDate(purchase.date)}</p>
              </div>
            </div>

            {purchase.clientPhone && (
              <div className='form-field'>
                <label>Téléphone</label>
                <p className='font-medium'>{purchase.clientPhone}</p>
              </div>
            )}

            <div className='form-field'>
              <label>Mode(s) de paiement</label>
              {purchase.paymentMethods ? (
                <div className='payment-methods-display'>
                  {purchase.paymentMethods.map((pm, index) => (
                    <p key={index} className='font-medium capitalize'>
                      {pm.method.replace('-', ' ')}: {formatCurrency(pm.amount)}
                    </p>
                  ))}
                </div>
              ) : (
                <p className='font-medium capitalize'>
                  {purchase.paymentMethod?.replace('-', ' ')}
                </p>
              )}
            </div>

            <div className='form-field'>
              <label className='mb-2'>
                Produit{purchase.items.length > 1 ? 's' : ''} acheté
                {purchase.items.length > 1 ? 's' : ''}
              </label>
              <div className='purchase-items'>
                {purchase.items.map((item, index) => (
                  <div key={index} className='purchase-item enhanced'>
                    {item.productImage ? (
                      <div
                        className='item-image'
                        onClick={() => setLocalImageModal(item.productImage)}
                      >
                        <img src={item.productImage} alt={item.productName} />
                      </div>
                    ) : (
                      <div className='no-image-placeholder'>
                        <Package size={20} />
                      </div>
                    )}
                    <div className='item-info'>
                      <div className='item-name'>{item.productName}</div>
                      <div className='item-details'>
                        {item.quantity} × {formatCurrency(item.unitPrice)} ={' '}
                        {formatCurrency(item.total)}
                        {(item.productSize || item.productColor) && (
                          <div className='item-specs'>
                            Détails:{' '}
                            {[item.productSize, item.productColor]
                              .filter(Boolean)
                              .join(', ')}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className='form-grid cols-2'>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '15px',
                }}
                className='form-field'
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label>Statut de livraison</label>
                  {(purchase.deliveryStatus || 'default') === 'default' ? (
                    <span> - </span>
                  ) : (
                    <span
                      className={`badge ${
                        (purchase.deliveryStatus || 'pending') === 'delivered'
                          ? 'success'
                          : 'warning'
                      }`}
                    >
                      {(purchase.deliveryStatus || 'pending') === 'delivered'
                        ? 'Livré'
                        : 'À livrer'}
                    </span>
                  )}
                </div>

                <div>
                  {purchase.deliveryStatus !== 'default' &&
                    purchase.adressDelivery && (
                      <div className='form-field'>
                        <label>Lieu de livraison</label>
                        <p className='font-small'>{purchase.adressDelivery}</p>
                      </div>
                    )}
                </div>
              </div>

              {purchase.observations && (
                <div className='form-field'>
                  <label>Observations</label>
                  <p className='font-medium' style={{ fontStyle: 'italic' }}>
                    {purchase.observations}
                  </p>
                </div>
              )}
            </div>

            <div className='pt-4 border-t'>
              <div className='purchase-totals'>
                <div className='total-row'>
                  <span>Total:</span>
                  <span className='total-amount'>
                    {formatCurrency(purchase.totalAmount)}
                  </span>
                </div>
                {purchase.totalPaid !== undefined && (
                  <div className='total-row'>
                    <span>Payé:</span>
                    <span>
                      {formatCurrency(
                        purchase.paymentMethods?.reduce(
                          (total, pm) => total + Number(pm.amount || 0),
                          0,
                        ) || 0,
                      )}
                    </span>
                  </div>
                )}
                {purchase.remainingAmount > 0 && (
                  <div className='total-row remaining'>
                    <span>Reste à payer:</span>
                    <span className='remaining-amount'>
                      {formatCurrency(purchase.remainingAmount)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className='form-row mt-6' style={{ flexDirection: 'row' }}>
            <button onClick={onClose} className='btn secondary flex-1'>
              Fermer
            </button>
            <button
              onClick={() => {
                onEdit(purchase)
                onClose()
              }}
              className='btn primary flex-1'
            >
              <Edit2 size={16} className='btn-icon' />
              Modifier
            </button>
          </div>
        </div>

        {localImageModal && (
          <div
            className='modal-overlay'
            onClick={() => setLocalImageModal(null)}
          >
            <div
              className='modal-content image-modal'
              onClick={(e) => e.stopPropagation()}
            >
              <div className='image-modal-header'>
                <button
                  onClick={() => setLocalImageModal(null)}
                  className='btn secondary'
                >
                  <X size={20} />
                </button>
              </div>
              <div className='image-modal-body'>
                <img
                  src={localImageModal}
                  alt='Imag agrandie'
                  className='full-image'
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PurchaseDetailModal
